import {
    Component,
    ojs,
    app,
    state,
    v,
    each,
    State,
} from "modular-openscriptjs";
import { monetary, either, cleanDispose, isMobile } from "../../helpers";
import SearchResultProductView from "./SearchResultProductView";
import { tool } from "../../fotastart";
import ViewProductCanvas from "../Offcanvas/ViewProductCanvas";
import ViewProductModal from "../Modals/ViewProductModal";

const h = app("h");
const dc = app("dc");

ojs(SearchResultProductView, ViewProductCanvas, ViewProductModal);

export default class ViewProduct extends Component {
    holder = null;

    constructor() {
        super();
        this.activeImage = state("");
    }

    render(productState, holder) {
        const product =
            productState instanceof State ? productState.value : productState;
        if (!product?.id) return h.empty();

        if (this.activeImage.value === "" && product.images?.length > 0) {
            this.activeImage.value = product.images[0].path;
        } else if (this.activeImage.value === "" && product.thumbnail_path) {
            this.activeImage.value = product.thumbnail_path;
        }

        const userCurrency = dc.userCurrency;

        return h.div(
            { class: "view-product-container" },

            // Main Product Section
            // Image Section
            h.div(
                { class: "col-12 col-md-6" },
                either(product.images.length > 0, () => [
                    h.div(
                        {
                            class: "rounded-4 overflow-hidden shadow-sm mb-3 bg-light",
                        },
                        v(
                            this.activeImage,
                            (img) =>
                                h.img({
                                    src: img,
                                    class: "img-fluid w-100",
                                    style: "object-fit: contain;",
                                    alt: product.name,
                                }),

                            {
                                class: "d-block",
                                c_attr: {
                                    class: "d-block",
                                },
                            },
                        ),
                    ),
                    // Thumbnails
                    either(product.images.length > 1, () =>
                        h.div(
                            {
                                class: "d-flex gap-2 overflow-x-auto pb-2 px-4 scrollbar-hidden",
                                style: "scrollbar-width: none;",
                            },
                            each(product.images, (img) =>
                                h.div(
                                    {
                                        class: "rounded-3 overflow-hidden border cursor-pointer flex-shrink-0",
                                        style: v(
                                            this.activeImage,
                                            (active) =>
                                                `width: 70px; height: 70px; border-width: 2px !important; border-color: ${active === img.path ? "#0d6efd" : "#dee2e6"} !important; transition: all 0.2s;`,
                                        ),
                                        listeners: {
                                            click: () =>
                                                (this.activeImage.value =
                                                    img.path),
                                        },
                                    },
                                    h.img({
                                        src: img.path,
                                        class: "w-100 h-100 object-fit-cover",
                                    }),
                                ),
                            ),
                        ),
                    ),
                ]),
            ),

            h.div(
                {
                    class: "col-12 col-md-6 bg-white p-4 mb-4 border-0 rounded-4",
                },
                h.div(
                    { class: "row g-4" },

                    // Content Section
                    h.div(
                        { class: "col-12 d-flex flex-column" },
                        h.h2({ class: "fw-bold mb-1 text-dark" }, product.name),

                        h.h3(
                            { class: "text-dark fw-bold mb-2" },
                            monetary(
                                product.final_price ||product.selling_price || product.price,
                                userCurrency,
                            ),
                        ),

                        // Description (Now below Price)
                        h.p(
                            {
                                class: "text-muted mb-4",
                                style: "font-size: 0.95rem; line-height: 1.6;",
                            },
                            product.short_description,
                        ),

                        // Features (Vertical List)
                        h.div(
                            { class: "features-list mb-4" },
                            each(product.features, (feature) =>
                                h.div(
                                    { class: "mb-4 pb-3" },
                                    h.div(
                                        {
                                            class: "d-flex justify-content-between align-items-center mb-1 flex-wrap",
                                        },
                                        h.span(
                                            { class: "fw-bold text-dark fs-5" },
                                            feature.name,
                                        ),
                                        h.span(
                                            { class: "badge bg-secondary bg-opacity-10 text-secondary border border-secondary border-opacity-25 rounded-pill px-3 py-1 fw-medium" },
                                            h.call(() => {
                                                switch (feature.choice_type) {
                                                    case "single_choice":
                                                        return "Single Choice";
                                                    case "multiple_choice":
                                                        return "Multiple Choice";
                                                    case "text":
                                                        return "Free Text";
                                                    case "boolean":
                                                        return "Yes/No";
                                                    case "number":
                                                        return "Number";
                                                    case "range":
                                                        return "Range";
                                                    default:
                                                        return "Unknown";
                                                }
                                            })
                                        )
                                    ),
                                    h.div(
                                        { class: "options-list d-flex flex-wrap gap-2 mt-3" },
                                        either(
                                            feature.choice_type === "number",
                                            () => [
                                                h.span(
                                                    { class: "badge bg-secondary bg-opacity-10 text-secondary border border-secondary border-opacity-25 rounded-pill flex-wrap px-3 py-2 fw-semibold d-flex align-items-center gap-2" },
                                                    h.span(
                                                        { class: "text-wrap" },
                                                        feature.value_label
                                                            ? `${feature.value_label}`
                                                            : "No placeholder set",
                                                    ),
                                                ),
                                                either(feature.has_different_prices, () =>
                                                    h.span(
                                                        { class: "badge bg-primary bg-opacity-10 text-primary border border-primary border-opacity-25 rounded-pill px-3 py-2 fw-semibold d-flex align-items-center gap-2" },
                                                        h.span({ class: "fs-6" }, "Rate:"),
                                                        h.span(
                                                            { class: "badge bg-white text-primary shadow-sm border border-primary border-opacity-25 rounded-pill px-2 py-1 ms-1" },
                                                            `Every ${feature.price_interval} = ${monetary(feature.price_per_interval, userCurrency)}`,
                                                        ),
                                                    ),
                                                ),
                                            ],
                                            () =>
                                                each(feature.values, (option) =>
                                                    h.span(
                                                        { class: "badge bg-primary bg-opacity-10 text-primary border border-primary border-opacity-25 rounded-pill flex-wrap px-3 py-2 fw-semibold d-flex align-items-center gap-2" },
                                                        h.span({ class: "fs-6" }, option.value),
                                                        either(feature.has_different_prices, () =>
                                                            h.span(
                                                                { class: "badge bg-white text-primary shadow-sm border border-primary border-opacity-25 rounded-pill px-2 py-1 ms-1" },
                                                                option.price > 0
                                                                    ? monetary(option.final_price || option.price, userCurrency)
                                                                    : monetary(product.final_price || product.selling_price || product.price, userCurrency)
                                                            )
                                                        )
                                                    )
                                                ),
                                        ),
                                    )
                                )
                            )
                        ),

                        // Extras (Vertical List left aligned)
                        either(product.extras.length > 0, () =>
                            h.div(
                                { class: "extras-list mb-4" },
                                h.label(
                                    { class: "fw-bold text-dark mb-3 d-block fs-5" },
                                    "Extras",
                                ),
                                each(product.extras, (extra) =>
                                    h.div(
                                        {
                                            class: "d-flex align-items-center justify-content-between p-3 mb-2 rounded-4 border border-secondary border-opacity-10 bg-white shadow-sm flex-wrap gap-1",
                                        },
                                        h.div(
                                            { class: "fw-semibold text-dark fs-6 d-flex align-items-center gap-3" },
                                            h.span(extra.name),
                                            h.span({ class: "badge bg-secondary bg-opacity-10 text-secondary border border-secondary border-opacity-25 rounded-pill px-3 py-1 fw-medium" }, `Qty: ${extra.quantity || 1}`)
                                        ),
                                        h.div(
                                            { class: "badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 rounded-pill px-3 py-2 fw-bold fs-6" },
                                            `+ ${monetary(extra.price * (extra.quantity || 1), userCurrency)}`,
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        );
    }

    async showProduct(product) {
        if (this.holder) {
            cleanDispose(this.holder);
        }

        if (isMobile()) {
            this.holder = tool.offcanvas(
                h.ViewProductCanvas(h.ViewProduct(product, "offcanvas"), {
                    class: "p-0 rounded-top-5",
                }),
            );
        } else {
            this.holder = tool.plainModal(
                h.ViewProductModal(h.ViewProduct(product, "modal")),
            );
        }

        this.holder.show();
    }

    closeProductView() {
        this.holder.hide();
    }

    cleanUp() {
        if (this.holder) {
            cleanDispose(this.holder);
        }
    }
}

ojs(ViewProduct);
